/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import CardInfo from "../../components/CardInfo";
import Content from "../../components/Content";
import { BarChart } from '../../components/Recharts/BarChart'
import { PieChartRetornoMensal } from '../../components/Recharts/PieChartRetornoMensal'
import { PieChartPixPorInstituicao } from '../../components/Recharts/PieChartPixPorInstituicao'
import _ from 'lodash'

import api from "../../services/api";

import {
  ajustaActiveClassMenu,
  makeRandomColor,
  makeRandomColorRGB,
  decrypt
} from "../../util/rotinas";

export default function Gerencial() {
  const [loading, setLoading] = useState(false);
  const [qtdClientesInfarma, setQtdClientesInfarma] = useState(0);
  const [qtdClientesComContaPIX, setQtdClientesComContaPIX] = useState(0);

  const [retornoMensal, setRetornoMensal] = useState([]);
  const [pixPorCliente, setPixPorCliente] = useState([]);
  const [pixPorClientePorInstituicao, setPixPorClientePorInstituicao] = useState([]);
  const [pixPorPorInstituicao, setPixPorPorInstituicao] = useState([]);
  const [retornoAproximado, setRetornoAproximado] = useState(null)

  const [dataAtual, setDataAtual] = useState(undefined)
  useEffect(() => {
    if (dataAtual === undefined) {
      let data = new Date();
      let dia = String(data.getDate()).padStart(2, '0');
      let mes = String(data.getMonth() + 1).padStart(2, '0');
      let ano = data.getFullYear();
      let dataAtual = ano + '-' + mes + '-' + dia;
      setDataAtual(dataAtual)
    }
  }, [dataAtual])



  async function getClientes() {
    setLoading(true);
    try {
      await api.get(`customer`).then((res) => {
        setQtdClientesInfarma(res.data.data.length)
        let temp = res.data.data.filter(cliente => cliente.InstituitionCustomer.length > 0)
        setQtdClientesComContaPIX(temp.length)
      })
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }


  async function fetchData() {
    try {
      setLoading(true);
      await api.get("dashboard?type=SALE").then((res) => {
        const data = res.data.data;
        getPixPorCliente(data);
        getPixPorClientePorInstituicao(data);
        getPixPorPorInstituicao(data)
        getRetornoMensal(data)
      });
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  const getPixPorCliente = function (data) {
    const tp = data.movimentacoesPixCliente;
    const dataArray = [];
    if (tp.length > 0) {
      tp.forEach((t) => {
        dataArray.push({
          nome: t.name,
          quant: Number(t.soma),
          color: makeRandomColor(),
        });
      });
      setPixPorCliente(dataArray);
    }
  };

  const getPixPorClientePorInstituicao = function (data) {
    const tp = data.movimentacoesPixClientePorInstituicao;
    const dataArray = [];
    const labels = []
    tp.forEach(item => {
      if (!labels.includes(item.fantasy_name)) {
        labels.push(item.fantasy_name)
      }
    })
    labels.forEach(label => {
      let temp = {}
      tp.forEach(item => {
        temp.fantasy_name = label
        temp.color = makeRandomColorRGB()
        if (item.fantasy_name === label) {
          if (item.instituition_id === 1) {
            temp.MATERA = item.total
          }
          else if (item.instituition_id === 2) {
            temp.SHIPAY_ITAU = item.total
          }
        }
      })
      dataArray.push(temp)
    })
    setPixPorClientePorInstituicao(dataArray)
  };

  function handleNameInstituition(instituition_id) {
    if (instituition_id == 1) {
      return 'MATERA'
    }
    else if (instituition_id == 2) {
      return 'SHIPAY_ITAU'
    }
    else if (instituition_id == 3) {
      return 'BB'
    }
  }

  const getPixPorPorInstituicao = function (data) {
    const tp = data.movimentacoesPorInstituicao;
    const dataArray = [];
    tp.forEach(item => {
      dataArray.push({
        ...item,
        instituition: handleNameInstituition(item.instituition_id)
      })
    })
    setPixPorPorInstituicao(dataArray)
  };

  const getRetornoMensal = function (data) {

    const tp = data.retornoMensal
    let grouped_data = Object.values(_.groupBy(tp, item => item.mes)).map(item => {
      return {
        mes: item[0].mes,
        total: _.sumBy(item, (o) => Number(o.lucro) > Number(o.lucro_percent) ? Number(o.lucro) : Number(o.lucro_percent))
      }
    }
    )
    const dataArray = [];
    if (grouped_data.length > 0) {
      grouped_data.forEach((t) => {
        dataArray.push({
          data: t.mes,
          mes: handleData(t.mes),
          quant: Number(t.total),
          color: makeRandomColorRGB(),
        });
      });
      setRetornoMensal(dataArray);
    }
  };

  useEffect(() => {
    if (dataAtual !== undefined) {
      if (retornoMensal.length > 0) {
        let temp = retornoMensal.filter(item => Number(item.data) == Number(dataAtual.split('-')[1]))
        setRetornoAproximado(temp)
      }
    }
  }, [retornoMensal])

  function handleData(data) {
    if (data == "1") {
      return `JAN`
    }
    else if (data == "2") {
      return `FEV`
    }
    else if (data == "3") {
      return `MAR`
    }
    else if (data == "4") {
      return `ABR`
    }
    else if (data == "5") {
      return `MAI`
    }
    else if (data == "6") {
      return `JUN`
    }
    else if (data == "7") {
      return `JUL`
    }
    else if (data == "8") {
      return `AGO`
    }
    else if (data == "9") {
      return `SET`
    }
    else if (data == "10") {
      return `OUT`
    }
    else if (data == "11") {
      return `NOV`
    }
    else if (data == "12") {
      return `DEZ`
    }
  }

  function formatReal(valor) {
    return Number(valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })
  }

  useEffect(() => {
    const u = decrypt(localStorage.getItem("@ipm:user"), true);
    const acessos = u?.profile?.access;
    let aList;

    aList = acessos?.filter(
      (a) =>
        a.screen_name === "customer" &&
        a.action === "new"
    );

    ajustaActiveClassMenu("dashMenu", "dashMenu");
    getClientes();
    fetchData();
  }, []);

  return (

    <div
      className="row"
      style={{
        padding: "20px 20px 0 20px",

        width: "100%",
      }}
    >
      <div style={{ padding: "0" }} className="col-lg-12 col-12">
        <div className="row">
          <div className="col-lg-4 col-4">
            <CardInfo
              className="small-box bg-warning"
              loading={loading}
              information={qtdClientesInfarma}
              title="Clientes Infarma"
              icon="fa fa-user"
            />
          </div>

          <div className="col-lg-4 col-4">
            <CardInfo
              className="small-box bg-info"
              loading={loading}
              information={qtdClientesComContaPIX}
              title="Clientes com conta PIX"
              icon="fa fa-bank"
            />
          </div>
          <div className="col-lg-4 col-4">
            <CardInfo
              className="small-box bg-success"
              loading={loading}
              information={retornoAproximado && retornoAproximado.length > 0 ? `${formatReal(String(retornoAproximado[0].quant))}` : `R$ 0`}
              title={retornoAproximado && retornoAproximado.length > 0 ? `Retorno Aproximado (${retornoAproximado[0].mes}) ` : `Não há faturamento no mês atual`}
              icon="fa fa-money"
            />
          </div>
        </div>
      </div>
      <div style={{ padding: "0" }} className="col-lg-12 col-12">
        <div className="row">
          <div style={{ display: 'flex', padding: "0 10px", gap: "10px" }} className="col-lg-12 col-12">
            <div style={{ padding: "0" }} className="col-lg-4 col-4">
              <Content>
                <PieChartRetornoMensal dados={retornoMensal} title={'Retorno Mensal (Últimos 6 meses)'} />
              </Content>
              <Content>
                <PieChartPixPorInstituicao dados={pixPorPorInstituicao} title={'PIX por Instituicao'} />
              </Content>
            </div>
            <div style={{ padding: "0" }} className="col-lg-8 col-8">
              <Content>
                <BarChart dados={pixPorClientePorInstituicao} title='Movimentações PIX por Cliente' />
              </Content>
              {/* <Content>
                <BarChart dados={pixPorClientePorInstituicao} title='Movimentações PIX por Cliente' />
              </Content> */}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}